import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import questionMark from "../../../Assets/images/qstn.png";
import information from "../../../Assets/images/information.svg"
import greenCheck from "../../../Assets/images/green_check.svg";
import PopUp from "../../PopUp";
import { testDescription, medicalStatus } from "../data";
import { tpaRetrigger } from "../action";
import { convertToIST } from "../agentUtils";
import { customerPortalStatus } from "../../../actions/dashBoardActions";
const MedicalRequirement = ({ accDetails, tpaReq, data, setDescAndShowMed }) => {
  const popupRef = useRef(null);
  const [popupHeight, setPopupHeight] = useState("auto");
  const [openAccordion, setOpenAccordion] = useState(null);
  const [desciprtion, setDescription] = useState("");
  const [show, setShow] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState(null);
  const dispatch = useDispatch();
  const filteredData = data?.filter(item => 
    !item?.tpaWaiveOffDetails || 
    !(item?.tpaWaiveOffDetails?.tpaWaiveOffType === "WAIVE_OFF_MEDICALS" && item?.raisedBy === "SYSTEM") 
  );
  

  useEffect(() => {
    if (popupRef.current) {
      setPopupHeight(popupRef.current.scrollHeight);
    }
  }, [data]);

  const renderDate = (date) => {
    const istDate = convertToIST(date);
    return istDate;
  };
  const showTooltip = (description) => {
    // console.log("description", description);
    setShow(!show);
    setDescription(description);
  };
  // const handleClick = (description) => {
  //     setSelectedDescription(description);
  //     setShowModal(true);
  // };

  const retriggerHandler = (status, id, regCode) => {
    const data = {
      id: id,
      proposalNumber: accDetails?.proposalBasicDetails?.proposalNumber,
    };
    if (regCode) {
      return;
    } else {
      dispatch(
        tpaRetrigger(data, () => {
          dispatch(
            customerPortalStatus(
              accDetails?.proposalBasicDetails?.proposalNumber,
              () => {}
            )
          );
        })
      );
    }
  };
  const sortByDate = (list=[]) => {
    return [...list].sort((a, b) => new Date(a.date) - new Date(b.date));
  };
  return (
    <ul ref={popupRef} className="card-body med-body">
      {sortByDate(filteredData)?.map((item, index) => {
        let showTPABtn= item.tpaWaiveOffDetails===null || item?.tpaWaiveOffDetails?.tpaWaiveOffType!=='ONLY_TPA'
        return (
          <li className="rvsd_dwnld_outr med-card">
            {/* <div className="rvsd_dwnld mB-10" >
                            {item?.tpaStatus && <span>{`${medicalStatus[item?.tpaStatus]}`}</span>}
                            {!item?.tpaStatus && !item?.tpaRegistrationCode && <span>Yet to start</span>}
                            {!item?.tpaStatus && item?.tpaRegistrationCode &&  <span>Pending medical appointment</span>}
                            {(item?.tpaStatus === "MDRU" || item?.tpaStatus === "MDRA")&& <span className='status-span'><img src={greenCheck}/></span>}
                        </div> */}
            <div className="rvsd_dwnld med-card-first">
              <div className="med-card-info">
                {item?.tpaStatus && (
                  <span>{`${medicalStatus[item?.tpaStatus]}`}</span>
                )}
                {!item?.tpaStatus && !item?.tpaRegistrationCode && (
                  <span>Yet to start</span>
                )}
                {!item?.tpaStatus && item?.tpaRegistrationCode && (
                  <span>Pending medical appointment</span>
                )}
                {(item?.tpaStatus === "MDRU" || item?.tpaStatus === "MDRA") && (
                  <span className="status-span">
                    <img src={greenCheck} alt={"greentick"} />
                  </span>
                )}
              </div>

              <div className="time-stamp">{renderDate(item?.date)}</div>
            </div>
            <div className="med-test">
              <div className="rvsd_dwnld">
                Medical Test Category
                <span className="ml-1"> - &nbsp; </span>
                {/* <span className='ml-1'> - </span> */}
                {/* <span className='ml-1'>{item.tpaTestCode}</span> */}
              </div>

              <div className="test-category">
                {item?.tpaTestStatusMap && Object.entries(item?.tpaTestStatusMap).map(
                  ([category, tests]) => {
                     const tpaDescription = tests[0]?.categoryDescription || "";
                     return (
                      <div key={category} className="test-blk">
                        <div className="test-code test-wrapper">
                          <span>{category}</span>
                          <div className="rvsd_blk-tooltip">
                          <span className="tooltipbx">
                            <img
                              src={information}
                               onClick={() => {
                            showTooltip(tpaDescription);
                            setDescAndShowMed(true, tpaDescription)
                          }}
                              width="14"
                              height="14"
                              alt="info"
                            />
                            <span className="tooltiptext">{tpaDescription}</span>
                          </span>
                        </div>
                        </div>
                        
                        <ul className="test-list">
                          {tests.map((test, index) => (
                            <li key={index} className={test?.status?.toLowerCase() !== 'waivedoff' ? 'underGotest' :'waivedOff'}>
                              <span>{test.value}</span>
                              <span>{test?.status?.toLowerCase() !== 'waivedoff' ? 'Undergo a test' :'Test Requirement dropped'}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
{
    showTPABtn
    &&
            <div className="rvsd_dwnld med-blk-btn">
              <div className="mt-1">Click here to</div>
              {
                <button
                  className={`med-btn mL-15 ${
                    item?.tpaRegistrationCode && "disable-tpa"
                  } `}
                  onClick={() => {
                    retriggerHandler(
                      item?.tpaStatus,
                      item?.tpaId,
                      item?.tpaRegistrationCode
                    );
                  }}
                >
                  Retrigger
                </button>
              }
              {/* {<span className='line'>|</span>}
                            {<span className="med-btn" onClick={() => {}}>Book Medicals</span>} */}
            </div>

}
            {/* <div className='rvsd_dwnld time-stamp'>{renderDate(item?.date)}</div> */}
          </li>
        );
      })}
    </ul>
  );
};

export default MedicalRequirement;
